/* eslint-disable no-debugger */
<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">Members List</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <!-- <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col> -->
      </b-row>
      <!-- Card stats -->
      <!-- <b-row>
        <b-col xl="3" md="6">
          <stats-card
            title="Total traffic"
            type="gradient-red"
            sub-title="350,897"
            icon="ni ni-active-40"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                ><i class="fa fa-arrow-up"></i> 3.48%</span
              >
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col md="6" xl="3">
          <stats-card
            title="Total traffic"
            type="gradient-orange"
            sub-title="2,356"
            icon="ni ni-chart-pie-35"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                ><i class="fa fa-arrow-up"></i> 12.18%</span
              >
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col md="6" xl="3">
          <stats-card
            title="Sales"
            type="gradient-green"
            sub-title="924"
            icon="ni ni-money-coins"
          >
            <template slot="footer">
              <span class="text-danger mr-2"
                ><i class="fa fa-arrow-down"></i> 5.72%</span
              >
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col md="6" xl="3">
          <stats-card
            title="Performance"
            type="gradient-info"
            sub-title="49,65%"
            icon="ni ni-chart-bar-32"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                ><i class="fa fa-arrow-up"></i> 54.8%</span
              >
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
      </b-row> -->
    </base-header>
    <b-container fluid class="container-fluid mt--6">
      <b-row class="starter-page">
        <b-col lg="12" class="card-wrapper ct-example">
          <b-card no-body>
            <b-card-header>
              <h3 class="mb-0">Policies</h3>
            </b-card-header>
            <b-card-body>
              <b-col
                cols="12"
                class="
                  d-flex
                  justify-content-center justify-content-sm-between
                  flex-wrap
                "
              >
                <base-input>
                  <select
                    class="form-control"
                    v-model.number="page.page_size"
                    placeholder="Per page"
                    @change="getPolicies"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                </base-input>
                <!-- <el-select
                  class="select-primary pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                    :name="item"
                  >
                  </el-option>
                </el-select> -->

                <div>
                  <base-input
                    v-model="page.keyword"
                    prepend-icon="fas fa-search"
                    placeholder="Search..."
                    @change="getPolicies"
                  >
                  </base-input>
                </div>
              </b-col>
              <b-col
                cols="12"
                class="
                  d-flex
                  justify-content-center justify-content-sm-between
                  flex-wrap
                "
              >
                <b-list-group flush class="col-12 my--12">
                  <b-list-group-item
                    class="px-0"
                    v-for="user in users"
                    :key="user.userId"
                  >
                    <b-row align-v="center">
                      <b-col class="ml--2">
                        <h4 class="mb-0">
                          <a href="#!"
                            >{{ user.firstName }} {{ " "
                            }}{{ user.lastName }}</a
                          >
                        </h4>
                        <!-- <span :class="`text-${user.statusType}`">● </span> -->
                        <small>{{ user.email }}</small>
                        <h6>{{ user.mobile }}</h6>
                      </b-col>
                      <b-col class="ml--2">
                        <h4 class="mb-0">
                          <a href="#!">{{ user.policyNo  }} </a>
                        </h4>
                        <h4>₹{{ user.premium.$numberDecimal}}</h4>
                      </b-col>
                      <b-col class="ml--2">
                        <h4 class="mb-0">
                          <a href="#!">{{ user.createdAt |FORMATDATE }} </a>
                        </h4>
                      </b-col>

                      <b-col cols="md-1" class="text-right">
                        <base-button
                          type="primary"
                          size="sm"
                          class="d-flex"
                          @click="getpdf(user.policy_id,user.policyNo)"
                          ><i class="ni ni-down"></i> Download</base-button
                        >
                      </b-col>
                      <!-- <b-col cols="md-1" class="text-right">
                        <base-button type="danger" size="sm" class="d-flex"
                          >Delete <i class="ni ni-fat-remove"></i
                        ></base-button>
                      </b-col> -->
                    </b-row>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-card-body>
            <div
              slot="footer"
              class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
              <base-pagination
                class="pagination-no-border"
                :value="parseInt(page.page_no)"
                :perPage="parseInt(page.page_size)"
                :total="parseInt(page.total)"
                :size="'5'"
                @change="paginationChanged($event)"
              >
              </base-pagination>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import BaseHeader from "@/components/BaseHeader";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { API } from "../../services/api.service";
import { useJwt } from "../../services/jwt.service";
import moment from 'moment';
export default {
  name: "starter-page",
  components: {
    BasePagination,
    BaseHeader,
    RouteBreadCrumb
  },
  props: {},
  created() {
    debugger;
    this.getPolicies();
  },
  filters: {
    // UPPERCASE(value) {
    //   return value.toUpperCase();
    // }
    FORMATDATE(str){

        if (str != null) {
            return moment(str).format("DD MMM YYYY");
        }
        return "";
    }
  },
  mixins: [clientPaginationMixin],
  data() {
    return {
      currentUser: useJwt.getUserInfo(),
      searchQuery: "",
      page: {
        page_size: 10,
        page_no: 1,
        keyword: "",
        total: 0
      },
      users: [
        {
          id: 1,
          img: "img/theme/team-1.jpg",
          name: "John Michael",
          status: "Online",
          statusType: "success"
        },
        {
          id: 2,
          img: "img/theme/team-2.jpg",
          name: "Alex Smith",
          status: "In a meeting",
          statusType: "danger"
        },
        {
          id: 3,
          img: "img/theme/team-3.jpg",
          name: "Samantha Ivy",
          status: "Offline",
          statusType: "danger"
        },
        {
          id: 4,
          img: "img/theme/team-4.jpg",
          name: "John Michael",
          status: "Online",
          statusType: "success"
        }
      ]
    };
  },
  methods: {
    getPolicies() {
      let params = {
        page_size: this.page.page_size,
        page_no: this.page.page_no,
        keyword: this.page.keyword ? this.page.keyword : ""
      };
      API.GETALL_GMC({ params })
        .then(res => {
          if (res.data.ok) {
            this.users = res.data.result.items;
            this.page = res.data.result.page;
          }
        })
        .catch(err => {
          swal.fire({
            title: `${err}`,
            buttonsStyling: false,
            type: "error",
            confirmButtonClass: "btn btn-danger btn-fill"
          });
        });
    },
    getpdf(id,policyNo) {

      API.GMCINDIPDF(id)
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${policyNo}.pdf`); //or any other extension
          document.body.appendChild(link);
          link.click();
          //           swal.fire({
          //   title: `File fetched successfully!`,
          //   buttonsStyling: false,
          //   type: "success",
          //   confirmButtonClass: "btn btn-success btn-fill"
          // });
        })
        .catch(err => {
          swal.fire({
            title: `${err.response.data.message}`,
            buttonsStyling: false,
            type: "warning",
            confirmButtonClass: "btn btn-danger btn-fill"
          });
        });
    },
    paginationChanged(page) {
      this.page.page_no = page;
      this.page.keyword = this.page.keyword;
      this.getPolicies();
    }
  }
};
</script>
<style scoped>
.starter-page {
  min-height: calc(100vh - 380px);
}
</style>
